import { createSlice } from '@reduxjs/toolkit'
import { IStore } from '../types'
import { getDialog, getDialogMessages, getStat, searchChats } from './actions'

const initialState: IStore['statMailing'] = {
  view: null,
  data: null,
  dialog: null,
}

export const slice = createSlice({
  name: 'statMailing',
  initialState,
  reducers: {
    setDialog: (state, action) => {
      state.dialog = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getStat.fulfilled, (state, action) => {
      state.view = action.payload
    })
    builder.addCase(searchChats.fulfilled, (state, action) => {
      state.data = action.payload
    })
    builder.addCase(getDialog.fulfilled, (state, action) => {
      if (action.payload?.chat) {
        state.dialog = { ...action.payload, pages: { [action.payload.chat.page]: action.payload.chat } }
      }
    })
    builder.addCase(getDialogMessages.fulfilled, (state, action) => {
      if (state.dialog?.chat && action.payload) {
        state.dialog.pages[action.payload.page] = action.payload
        state.dialog.chat = action.payload
      }
    })
  },
})

export const StatMailingActions = slice.actions

export default slice.reducer
